export default __webpack_public_path__ + "static/media/371.94eee500.jpg";